import { render, staticRenderFns } from "./InitialContactsContainerCard.vue?vue&type=template&id=0cb545bd"
import script from "./InitialContactsContainerCard.vue?vue&type=script&lang=js"
export * from "./InitialContactsContainerCard.vue?vue&type=script&lang=js"
import style0 from "./InitialContactsContainerCard.vue?vue&type=style&index=0&id=0cb545bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports